import { render, staticRenderFns } from "./ArborescenceFolder.vue?vue&type=template&id=4ec36966&scoped=true&"
import script from "./ArborescenceFolder.vue?vue&type=script&lang=js&"
export * from "./ArborescenceFolder.vue?vue&type=script&lang=js&"
import style0 from "./ArborescenceFolder.vue?vue&type=style&index=0&id=4ec36966&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ec36966",
  null
  
)

export default component.exports